import {LqdHeaderTriggerHandler} from './lqd-header-trigger';
class LqdHeaderSearchHandler extends LqdHeaderTriggerHandler {
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdHeaderSearchHandler, { $element } );
};